
define(
	'Paystand.PaystandExtensionV2.Paystand'
,	[
		'Paystand.PaystandExtensionV2.Loader'
	]
,	function (
		PaystandLoader
	)
{
	'use strict';

	return {
		mountToApp: function mountToApp (container)
		{
			PaystandLoader.mountToApp(container);
		}
	};
});
